module.exports = __webpack_public_path__ + "img/team-1-800x800.53033970.jpg";